import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  color: ${o => o.theme.color.deprecated.obsidian};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

export const StarsWrap = styled.div`
  display: flex;
  align-items: center;
`

const Content = styled.div`
  ${TypeStyle.css.headlineExtraSmall}
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const RatingText = styled(Content)``

export const TotalReviews = styled(Content)``
